import { format, parse } from 'date-fns';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Anchor, Grid, GridColumn, Text, IButtonAnchorProps, Tag, Separator, TGridColumnWidth } from 'telia-front-react';
import { DigitarkNewsItem } from '../stores/DigitarkNewsStore';
import LanguageStore from '../stores/LanguageStore';

interface DigitarkNewsColumnProps extends DigitarkNewsItem {
  dateFormat?: string;
  button?: IButtonAnchorProps;
  showDate?: boolean;
  languageStore?: LanguageStore;
  grid?: TGridColumnWidth[];
}

const DigitarkNewsColumn: React.FC<DigitarkNewsColumnProps> = (props) => {
  return (
    <GridColumn width={props.grid}>
      <Grid noWrap={true}>
        <GridColumn width={['max']}>
          <Tag text="DIGITARK" size="tiny" purpose="recommended" />
          <Text>
            <Separator spacing="xxsmall" color="invisible" />
            {props.showDate && (
              <p className="text-tiny text__margin-none">
                <time dateTime={props.date}>
                  {format(parse(props.date, 'dd.MM.yyyy', Date.now()), props.dateFormat, { locale: props.languageStore.currentLocale })}
                </time>
              </p>
            )}
            <AnalyticsTrigger
              trigger={{
                id: `Link - ${props.originalTitle}`,
                callback: 'onClick',
              }}
            >
              <Anchor url={props.link} isTextColor={true} isUnderlined={false} className="text-weight-normal h4">
                {props.originalTitle}
              </Anchor>
            </AnalyticsTrigger>
          </Text>
        </GridColumn>
      </Grid>
    </GridColumn>
  );
};

DigitarkNewsColumn.defaultProps = {
  showDate: true,
  dateFormat: 'd. MMMM yyyy',
};

export default inject('languageStore')(observer(DigitarkNewsColumn));
